(() => {

    let frm = document.getElementById('frm');

    const initStateReady = () => {
        if (frm) {
            let btn = frm.querySelector('button');
            frm.addEventListener('submit', function (e) {
                frm.querySelector('button').disabled = true;
            });
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
